export const CONTACT_PHONE = process.env.NEXT_PUBLIC_CONTACT_PHONE || "0621116020";
export const CONTACT_WHATSAPP = (process.env.NEXT_PUBLIC_CONTACT_WHATSAPP || "393927855622")
    .replace(/\s/g, "")
    .replace(/\+/g, "");

export const CONTACT_PHONE_HREF = `tel:${CONTACT_PHONE}`;
